import React from 'react';
import DataImporter from './index';
import { Accordion, Table } from 'react-bootstrap';
import { createMeterReadings } from '../../api/meter-readingsAPI';
import handleDownloadTemplateHelper from './handleDownloadTemplateHelper';

const MeterReadingsImporter = ({ onComplete }) => {
  const handleDataImport = async (rows, onProgress) => {
    let count = 0;
    for (const row of rows) {
      try {
        await createMeterReadings({
          assetId: row.assetId,
          metersId: row.metersId,
          readingDate: row.readingDate,
          value: row.value,
        });
      } catch (err) {
        console.error('Failed to import meter reading', err);
      }
      count += 1;
      if (onProgress) onProgress(count);
    }
  };

  return (
    <>
      <div className='card h-100 p-16 rounded-0'>
        <p>
          You can bulk import <strong>meter readings</strong> into the system using an Excel or CSV file.
          This helps speed up onboarding or migration processes by avoiding manual entry.
          </p><p><strong>Note:</strong> There is no meter validation on bulk upload. Ensure the meter readings are valid before upload.
        </p>
        <p>Expand the list below to see the required fields.</p>
        <div className='mb-4'>
          <button
            className='btn btn-outline-secondary btn-sm'
            onClick={() => handleDownloadTemplateHelper('meterreadings')}
          >
            Download Template
          </button>
        </div>
        <div className='mb-4'>
          <Accordion alwaysOpen={false}>
            <Accordion.Item eventKey='0'>
              <Accordion.Header>Required Columns</Accordion.Header>
              <Accordion.Body>
                <p>Your file must include the following column headers:</p>
                <Table bordered size='sm'>
                  <thead className='table-light'>
                    <tr>
                      <th>Column Name</th>
                      <th>Type</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>assetId</td>
                      <td>Lookup</td>
                      <td>Valid <strong>asset number</strong> from the system</td>
                    </tr>
                    <tr>
                      <td>metersId</td>
                      <td>Lookup</td>
                      <td>Valid meter from the system. The default meter is 'Engine Hour Meter'</td>
                    </tr>
                    <tr>
                      <td>readingDate</td>
                      <td>Date</td>
                      <td>Date and time the reading was taken. (DD/MM/YYYY)</td>
                    </tr>
                    <tr>
                      <td>value</td>
                      <td>Number</td>
                      <td>The reading value</td>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <DataImporter
          entity='meter-readings'
          requiredFields={[
            {
              key: 'assetId',
              type: 'lookup',
              required: true,
              api: 'assets',
              nameField: 'assetNumber',
            },
            {
              key: 'metersId',
              type: 'lookup',
              required: false,
              api: 'meters',
              nameField: 'name',
            },
            { key: 'readingDate', type: 'datetime', required: true },
            { key: 'value', type: 'number', required: true },
          ]}
          onCommit={handleDataImport}
          onComplete={onComplete}
        />
      </div>
    </>
  );
};

export default MeterReadingsImporter;
